module.exports = __webpack_public_path__ + "resources/img/img_watchall_apm1_m.a0ff678d94087ce7b92d3015471a0d59.png";